// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 509 ? "6f31d389" : chunkId) + "." + {"161":"d22530ecf615d770","436":"423bff32fd4fbec0","509":"2a08dc45b0e208af","524":"c537cf00187e30f2"}[chunkId] + ".js";
};